import { Component, Input, OnInit } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { PersonGbMasterDetailEntryMeta, PersonGbVersionDetailEntryMeta } from '../../../../core/gb-api';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { KopfdatenelementComponent } from '../../../../shared/widgets/kopfdatenelement/kopfdatenelement.component';
import { KompaktTimepointComponent } from '../../../../shared/kompaktdarstellung/timepoint/kompakt-timepoint.component';
import { FormatUidPipe } from '../../../../shared/pipes/format/format-uid.pipe';
import { TranslateNamePipe } from '../../../../shared/pipes/simple/translate-name.pipe';

@Component({
  selector: 'cap-persongb-schweiz-juristische-person',
  templateUrl: './person-gb-schweiz-juristische-person.component.html',
  styleUrls: ['./person-gb-schweiz-juristische-person.component.scss'],
  imports: [KopfdatenelementComponent, KompaktTimepointComponent, TranslatePipe, FormatUidPipe, TranslateNamePipe]
})
export class PersonGbSchweizJuristischePersonComponent implements OnInit {
  @Input()
  public version: PersonGbVersionDetailEntryMeta;
  @Input()
  public master: PersonGbMasterDetailEntryMeta;

  constructor(public translate: TranslateService) {
    keysToTranslate<string>([
      'Adressen',
      'AHVNummer',
      'AHVVersichertennummer',
      'Anrede',
      'Gesellschaftsform',
      'Geschlecht',
      'Gueltig',
      'Heimatort',
      'NameEhegatte',
      'NameDerEltern',
      'Nationalitaet',
      'Personalien',
      'Personengruppe',
      'Sprache',
      'UidStatus',
      'Zivilstand'
    ]);
  }

  ngOnInit() {}
}
